import { FeberApiClient } from "../../services/commonServices"

interface ServicesResponse<T> {
    success: boolean;
    data: T;
    message: string;
}

export const getExpiringSoonOrExpiredOrders = async () => {
    const response = await FeberApiClient.get("Order/ExpiringSoonOrExpiredOrders");
    return !!response.data && !!response.data.success && response.data.data
}

export const dismissOrderNotifications = async (orderIds: string[]) => {
    const response = (await FeberApiClient.post<ServicesResponse<string[]>>("Order/DismissOrderNotifications", orderIds)).data
    return !!response.success || false;
}